import { useEffect } from "react";

/**
 * Session 44 · Robuste Header-Höhen-Messung
 *
 * Misst die tatsächliche kombinierte Höhe von fixiertem Header + TrustBar
 * (falls sichtbar) und stellt das Ergebnis als CSS-Variable `--pb24-header-h`
 * bereit. Reagiert auf:
 *   - Fenstergrößenänderungen (ResizeObserver)
 *   - TrustBar-Sichtbarkeit (Nav zeigt/versteckt sie beim Scrollen)
 *   - Sprachwechsel (längere Menü-Labels)
 *   - Font-Loading (Serifen laden nach → Nav ändert Höhe)
 *
 * Nutzung im CSS/Tailwind:
 *   style={{ paddingTop: "var(--pb24-header-h)" }}
 * oder in Tailwind arbitrary:
 *   className="pt-[calc(var(--pb24-header-h)+1rem)]"
 */
export default function HeaderHeightSensor() {
  useEffect(() => {
    const root = document.documentElement;
    const write = () => {
      // Alle fixed z-40+ Elemente oben in der Seite messen
      const nav = document.querySelector("nav.fixed, header.fixed, [data-testid='navbar']") ||
                  document.querySelector("nav") ||
                  document.querySelector("header");
      const trustBar = Array.from(document.querySelectorAll(".fixed"))
        .find((el) => el !== nav && el.getBoundingClientRect().top < 100 && el.getBoundingClientRect().height < 80 && el.getBoundingClientRect().height > 20);
      const navH = nav ? nav.getBoundingClientRect().height : 72;
      const tbH  = trustBar ? trustBar.getBoundingClientRect().height : 0;
      // Nur die Summe wenn TrustBar tatsächlich sichtbar ist (opacity > 0)
      const tbVisible = trustBar ? parseFloat(getComputedStyle(trustBar).opacity || "1") > 0.1 : false;
      const total = Math.round(navH + (tbVisible ? tbH : 0));
      root.style.setProperty("--pb24-header-h", `${total}px`);
      root.style.setProperty("--pb24-nav-h", `${Math.round(navH)}px`);
    };

    write();
    // ResizeObserver für Nav
    const nav = document.querySelector("nav") || document.querySelector("header");
    const ro = new ResizeObserver(() => write());
    if (nav) ro.observe(nav);
    document.querySelectorAll(".fixed").forEach((el) => ro.observe(el));

    // Scroll aktualisiert (TrustBar-Sichtbarkeit)
    const onScroll = () => window.requestAnimationFrame(write);
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    // Font-Loading
    if (document.fonts?.ready) document.fonts.ready.then(write);
    // Sprachwechsel: MutationObserver auf html[lang]
    const mo = new MutationObserver(write);
    mo.observe(document.documentElement, { attributes: true, attributeFilter: ["lang"] });

    return () => {
      ro.disconnect();
      mo.disconnect();
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);
  return null;
}
